<template>
  <button
    class="secondary-button w-full border-2 text-brand-black py-1 md:py-2 px-4 rounded bg-white hover:bg-brand-light-gray"
    :class="[
      classes.includes('border') ? classes : 'border-brand-green',
      classes,
      disabled ? 'bg-brand-dark-gray' : ''
    ]"
  >
    <template v-if="isLoading">
      <div class="py-2 md:py-1 flex justify-center">
        <SmallLoading />
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </button>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss"></style>
